import { createConsumer, type Consumer } from '@rails/actioncable'

let consumer: Consumer | null = null

export function getConsumer(): Consumer {
  if (!consumer) {
    const url = new URL('/cable', window.location.origin)
    url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
    consumer = createConsumer(url.toString())
  }
  return consumer
}

export function disconnectConsumer() {
  consumer?.disconnect()
  consumer = null
}
